import React from 'react'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Subtitle} from '../../../subtitle'
import {usePageStateSelector} from '../../../../hooks/state'
import {getComponentSettings} from '../../../../selectors/component'
import {useSettings} from '../../../../../hooks/settings'
import {settingsParams} from '../../../../../settingsParams'

export const Header = () => {
  const componentSettings = usePageStateSelector(getComponentSettings)
  const settings = useSettings(componentSettings)
  const ticketsTitleText = settings.get(settingsParams.ticketsTitleText)
  return <Subtitle dataHook={DH.subtitleTickets} text={ticketsTitleText} compact />
}
